import { ServiceFetch } from '../service-fetch'

export default class PointExchangeProductModel extends ServiceFetch {
    generatePointExchangeProductLastCode = (data) => this.authFetch({
        url: 'point-exchange-product/generatePointExchangeProductLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExchangeProductBy = (data) => this.authFetch({
        url: 'point-exchange-product/getPointExchangeProductBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getPointExchangeProductByCode = (data) => this.authFetch({
        url: 'point-exchange-product/getPointExchangeProductByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkDuplicate = (data) => this.authFetch({
        url: 'point-exchange-product/checkDuplicate',
        method: 'POST',
        body: JSON.stringify(data),
    })

    approvePointExchangeProductBy = (data) => this.authFetch({
        url: 'point-exchange-product/approvePointExchangeProductBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertPointExchangeProduct = (data) => this.authFetch({
        url: 'point-exchange-product/insertPointExchangeProduct',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updatePointExchangeProductBy = (data) => this.authFetch({
        url: 'point-exchange-product/updatePointExchangeProductBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deletePointExchangeProductByCode = (data) => this.authFetch({
        url: 'point-exchange-product/deletePointExchangeProductByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
    cancelPointExchangeProductByCode = (data) => this.authFetch({
        url: 'point-exchange-product/cancelPointExchangeProductByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
